import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withHttpTransferCacheOptions,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { RetailCommonModule } from 'retail/app/common/retail-common.module';
import { RetailCoreModule } from 'retail/app/core/retail-core.module';
import { RetailAnalyticsService } from 'retail/app/retail-analytics.service';
import { RetailAppRoutingModule } from 'retail/app/retail-app-routing.module';
import { RetailAppComponent } from 'retail/app/retail-app.component';
import { Firebase } from 'retail/app/retail-app.tokens';
import { environment } from 'retail/environments/environment';
import { createEnvProvider } from 'shared-ui/di/environment';
import { AnalyticsService } from 'shared-ui/providers/analytics.service';
import { AppErrorHandler } from 'shared-ui/providers/app-error-handler';
import { AppLogger } from 'shared-ui/providers/app-logger';
import { BaseInterceptor } from 'shared-ui/providers/base-interceptor';
import { TRANSLATIONS, getLanguage, getTranslations } from 'shared-ui/providers/locales';
import { ZasilkovnaPickup } from 'shared-ui/providers/zasilkovna-pickup';
import { SharedUiModule } from 'shared-ui/shared-ui.module';

@NgModule({
  bootstrap: [RetailAppComponent],
  declarations: [RetailAppComponent],
  imports: [BrowserModule, RetailCommonModule, RetailCoreModule, SharedUiModule, RetailAppRoutingModule],
  providers: [
    createEnvProvider(environment),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(
      withHttpTransferCacheOptions({ includeHeaders: ['Refresh-Token'] }),
      withNoIncrementalHydration()
    ),
    AppLogger,
    ZasilkovnaPickup,
    AnalyticsService,
    RetailAnalyticsService,
    { provide: Firebase, useFactory: () => (getApps().length ? getApp() : initializeApp(environment.firebase)) },
    { provide: LOCALE_ID, useFactory: getLanguage },
    { provide: TRANSLATIONS, useFactory: getTranslations },
    { provide: HTTP_INTERCEPTORS, useClass: BaseInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
  ],
})
export class RetailAppModule {}
